import Component from 'inferno-component';
import { Grid, Menu, Image } from 'semantic-ui-react';

export default class DesktopNavigation extends Component {
  render() {
    return (
      <div>
        <Grid>
          <Grid.Row>
            <Menu fluid defaultActiveIndex={0} widths={9} stackable floated   borderless color='violet'>
              <Menu.Item index={0} href='/'><Image className='mr-1' src={'assets/images/logo/ua-logo.svg'} size='mini' />UnivAdvert</Menu.Item>
              <Menu.Item index={1} href='/#hirdetesi-helyszinek'>Hirdetési helyszínek</Menu.Item>
              <Menu.Item index={2} href='/#kapcsolat'>Kapcsolat</Menu.Item>
            </Menu>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/navigation/DesktopNavigation.js